import { render, staticRenderFns } from "./certiticateChangeLogForm.vue?vue&type=template&id=56641f8a&"
import script from "./certiticateChangeLogForm.vue?vue&type=script&lang=js&"
export * from "./certiticateChangeLogForm.vue?vue&type=script&lang=js&"
import style0 from "./certiticateChangeLogForm.vue?vue&type=style&index=0&id=56641f8a&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports